import { FlowRunState } from 'flow-schema';

import { Tag, type TagProps, api } from 'common';

export const TerminalFlowRunStates = [...api.FlowRun.TerminalFlowRunStates];

export const FLOW_RUN_TAG_PROPS: Record<
  FlowRunState,
  {
    color: TagProps['color'];
  }
> = {
  [FlowRunState.Pending]: {
    color: 'pending',
  },
  [FlowRunState.PendingRetry]: {
    color: 'pending',
  },
  [FlowRunState.Queued]: {
    color: 'pending',
  },
  [FlowRunState.Running]: {
    color: 'primary',
  },
  [FlowRunState.Completed]: {
    color: 'success',
  },
  [FlowRunState.Failed]: {
    color: 'error',
  },
  [FlowRunState.Canceled]: {
    color: 'error',
  },
};

interface FlowRunStateTagProps {
  state: FlowRunState;
}

export function FlowRunStateTag(props: FlowRunStateTagProps) {
  const { state } = props;
  return <Tag {...FLOW_RUN_TAG_PROPS[state]}>{state}</Tag>;
}
